<div [innerHTML]="htmlAsString | sanitize: 'html'"></div>
